module.exports = __webpack_public_path__ + "img/essentia.76b5f015.png";